import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "person-card" }
const _hoisted_2 = { class: "num" }
const _hoisted_3 = { class: "person-card__content" }
const _hoisted_4 = { class: "person-card__name" }
const _hoisted_5 = { class: "person-card__rating" }
const _hoisted_6 = { class: "person-card__buttons buttons-inline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_EstateAgentReviewStars = _resolveComponent("EstateAgentReviewStars")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ResizableImage, {
      classes: "person-card__photo",
      url: _ctx.estateAgent.photoRelativeUrl,
      placeholder: "img/no-photo-user.png",
      backgroundImage: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.estateAgent.adCount), 1)
      ]),
      _: 1
    }, 8, ["url"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.estateAgent.fullName), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_EstateAgentReviewStars, {
          rating: _ctx.estateAgent.rating
        }, null, 8, ["rating"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: { name: 'AdAgentList', params: { urlName: _ctx.estateAgent.estateAgentUrlName }, hash: '#estate-offer-list' },
          tag: "button",
          class: "button button--primary reversed"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('EstateAgentPublicListItem.agency-list-link')), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          to: { name: 'AdAgentList', params: { urlName: _ctx.estateAgent.estateAgentUrlName } },
          tag: "button",
          class: "button button--primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('EstateAgentPublicListItem.agency-profile-link')), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}